import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "popup__inner" }
const _hoisted_2 = { class: "subscription-form__btn btns btns--large" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = {
  key: 0,
  class: "popup__tips"
}
const _hoisted_7 = { class: "popup__tips-text" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 1,
  class: "popup__tips"
}
const _hoisted_11 = { class: "popup__tips-text" }

import { computed, ref } from 'vue'
import { useWait } from '@/app/composables/useWait'

import { BillingView, PlanView } from '@/models/billing'
import { ValidationState } from '@/helpers/form'

import FormError from '@/components/ui/FormError.vue'
import ButtonSpinner from '@/components/ui/ButtonSpinner.vue'
import StripeCard from '@/app/components/billing/StripeCard.vue'
import StripeCardInfo from '@/app/components/billing/StripeCardInfo.vue'
import BasePopup from '@/components/ui/BasePopup.vue'

import { trialByPlan15535Variant } from '@/services/ab'
import {
  getTrialPolicy,
  PlatformTrialPolicy,
  trialByPlan15535Treatment,
} from '@/services/ab/15535_trial_by_plan'


export default /*@__PURE__*/_defineComponent({
  __name: 'SubscribePopup',
  props: {
    billing: {},
    plan: {}
  },
  emits: ['subscribed'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const wait = useWait()
const emit = __emit

const popup = ref<InstanceType<typeof BasePopup> | null>(null)
const stripeCard = ref<InstanceType<typeof StripeCard> | null>(null)

const visible = ref(false)
const validation = ref(new ValidationState())
const trialPolicy = ref<PlatformTrialPolicy | null>(null)

async function show(): Promise<void> {
  const variant = trialByPlan15535Variant()
  if (variant) {
    const period = props.plan.id === 'plan_monthly' ? 'monthly' : 'annual'
    trialPolicy.value = await getTrialPolicy(variant, period)
  }
  visible.value = true
  popup.value?.show()
}

function hide(): void {
  visible.value = false
  validation.value.reset()
  popup.value?.hide()
}

function onChangeHandler(): void {
  props.billing.cardEditMode = true
  validation.value.reset()
}

async function submitForm(event: Event): Promise<void> {
  event.preventDefault()
  await subscribe()
}

const hasTrialDays = computed(() => {
  if (!trialPolicy.value) {
    return true
  }
  return trialPolicy.value.trial_days !== null
})

const trialEnd = computed(() => {
  return props.billing.trialEnd(props.plan.id)
})

async function subscribe(): Promise<void> {
  try {
    let cardSuccess = true
    wait.start('Subscribing')
    if (props.billing.cardEditMode && stripeCard.value?.needsSaving()) {
      cardSuccess = await stripeCard.value?.save()
    }
    if (cardSuccess) {
      await props.billing.subscribeTo(props.plan)
      emit('subscribed')
      validation.value.reset()
      hide()
    }
    wait.end('Subscribing')
  } catch (error) {
    wait.end('Subscribing')
    validation.value.showErrors(error)
  }
}

const subscribePopupChargesText = computed(() => {
  if (props.plan.nickname === 'Annual' && props.plan.discount) {
    return (
      `charge the subscription fee of ${props.plan.price.perPeriod} to your payment ` +
      `method for your first ${props.plan.labels.period}, ` +
      `then ${props.plan.priceNoDiscount.perPeriod} ` +
      `for subsequent ${props.plan.labels.period}s on ${props.plan.labels.basis} basis until you cancel.`
    )
  }

  return (
    `charge the subscription fee of ${props.plan.price.perPeriod} ` +
    `to your payment method on ${props.plan.labels.basis} basis until you cancel.`
  )
})

__expose({
  show,
  hide,
})

return (_ctx: any,_cache: any) => {
  const _component_v_wait = _resolveComponent("v-wait")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(BasePopup, {
    ref_key: "popup",
    ref: popup,
    title: "Start reading today"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("form", {
          class: "subscription-form",
          onSubmit: submitForm
        }, [
          (visible.value && __props.billing.cardEditMode)
            ? (_openBlock(), _createBlock(StripeCard, {
                key: 0,
                ref_key: "stripeCard",
                ref: stripeCard,
                billing: __props.billing,
                "show-button": false,
                onSaved: _cache[0] || (_cache[0] = ($event: any) => (__props.billing.cardEditMode = false))
              }, null, 8, ["billing"]))
            : _createCommentVNode("", true),
          (visible.value && !__props.billing.cardEditMode)
            ? (_openBlock(), _createBlock(StripeCardInfo, {
                key: 1,
                ref: "stripeCardInfo",
                billing: __props.billing,
                onChange: onChangeHandler
              }, null, 8, ["billing"]))
            : _createCommentVNode("", true),
          _createVNode(_component_v_wait, { for: "Subscribing" }, {
            waiting: _withCtx(() => [
              _createElementVNode("span", _hoisted_2, [
                _cache[1] || (_cache[1] = _createTextVNode(" Processing... ", -1)),
                _createVNode(ButtonSpinner)
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("a", {
                class: "subscription-form__btn btns btns--large",
                onClick: subscribe
              }, [
                (_unref(trialByPlan15535Treatment)())
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Subscribe Now"))
                  : (__props.billing.isTrialOver)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Subscribe"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_5, "Start 5-day free trial"))
              ])
            ]),
            _: 1
          }),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "pre-auth-message" }, [
            _createTextVNode(" Upon entering your card details, we will authorize and "),
            _createElementVNode("b", null, [
              _createElementVNode("u", null, "immediately refund")
            ]),
            _createTextVNode(" a charge of $1. The trial will still cost $0. ")
          ], -1)),
          _createVNode(FormError, {
            errors: validation.value.errors,
            field: __props.plan.id
          }, null, 8, ["errors", "field"]),
          _cache[3] || (_cache[3] = _createElementVNode("button", {
            type: "submit",
            style: {"display":"none"}
          }, null, -1))
        ], 32)
      ]),
      (!__props.billing.isTrialOver)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, [
              _createTextVNode(" By clicking the " + _toDisplayString(_unref(trialByPlan15535Treatment)()
            ? '"Subscribe Now"'
            : '"Start 5-day free trial"') + " button above, you agree to our ", 1),
              _createVNode(_component_router_link, {
                target: "_blank",
                to: { name: 'site_terms' }
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("Terms of Use", -1)
                ]))]),
                _: 1
              }),
              _cache[6] || (_cache[6] = _createTextVNode(" and ", -1)),
              _createVNode(_component_router_link, {
                target: "_blank",
                to: { name: 'site_privacy' }
              }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode("Privacy Policy", -1)
                ]))]),
                _: 1
              }),
              _cache[7] || (_cache[7] = _createTextVNode(". ", -1)),
              (hasTrialDays.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "You may cancel any time in your free trial and you will not be charged. "))
                : _createCommentVNode("", true),
              _cache[8] || (_cache[8] = _createTextVNode(" To cancel, go to Billing and click on \"Cancel subscription.\" ", -1)),
              _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
              _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
              (hasTrialDays.value)
                ? (_openBlock(), _createElementBlock("strong", _hoisted_9, " Shortform will automatically continue your subscription at the end of your free trial on " + _toDisplayString(trialEnd.value) + " and " + _toDisplayString(subscribePopupChargesText.value), 1))
                : _createCommentVNode("", true),
              _cache[11] || (_cache[11] = _createTextVNode(" There are no refunds or credits for partial subscription periods. ", -1))
            ])
          ]))
        : (__props.billing.isTrialOver)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("p", _hoisted_11, [
                _cache[12] || (_cache[12] = _createTextVNode(" After you click the \"Subscribe\" button above, ", -1)),
                _createElementVNode("strong", null, "Shortform will " + _toDisplayString(subscribePopupChargesText.value), 1),
                _cache[13] || (_cache[13] = _createTextVNode(" You may cancel your subscription at any time. To cancel, go to Billing and click on \"Cancel subscription.\" There are no refunds or credits for partial subscription periods. ", -1)),
                _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
                _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1))
              ])
            ]))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }, 512))
}
}

})